<template v-if="model">
  <div
    class="text-muted pathway-progress"
    :style="completedPathway(model)"
    data-test="personal-pathway-outcome-text"
    :class="{ other: !isCurrentPathway }"
  >
    {{ model.cmsPersonalOutcomeTitle }}
    <div data-test="personal-pathway-progress-text" v-if="isPlaceholder(model)">
      <div class="selected-pathway">
        <span class="pathway-title">{{ getPathwayName() }}</span>
        <span class="pathway-status">Selected, no steps completed yet</span>
      </div>
    </div>
    <div data-test="personal-pathway-progress-text" v-else>
      Completed {{ model.cmsStepTitle }} - {{ displayDate(model.dateCompleted) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import moment from "dayjs";
import { PersonalPathwayCompletedStepApiModel } from "../../api-models";

const props = withDefaults(
  defineProps<{
    model: PersonalPathwayCompletedStepApiModel;
    isCurrentPathway?: boolean;
  }>(),
  {
    isCurrentPathway: true,
  },
);

const displayDate = (dateString: string | undefined): string => {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : "";
};

const completedPathway = (pathway: PersonalPathwayCompletedStepApiModel): string => {
  // Old functionality: Used to apply bold styling for current personal pathways and normal styling for other pathways
  // return pathway.personalPathwayIsCurrent ? "font-weight:bold" : "font-weight:normal";
  
  // New functionality: Always use normal font weight for all personal pathways
  return "font-weight:normal";
};

const isPlaceholder = (pathway: PersonalPathwayCompletedStepApiModel): boolean => {
  return pathway.stepIndex === -1;
};

const getPathwayName = (): string => {
  // Use the pathway title as the first choice for display
  if (props.model?.cmsPersonalPathwayTitle) {
    return props.model.cmsPersonalPathwayTitle;
  }
  // Fall back to the outcome title if pathway title isn't available
  if (props.model?.cmsPersonalOutcomeTitle) {
    return `Pathway for ${props.model.cmsPersonalOutcomeTitle}`;
  }
  // Last resort fallback
  return "Active pathway";
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.other {
  margin-top: 2rem;
}

.selected-pathway {
  display: flex;
  flex-direction: column;
  
  .pathway-title {
    font-weight: normal;
    margin-bottom: 0.25rem;
  }
  
  .pathway-status {
    font-style: italic;
    color: #6c757d;
    font-size: 0.9em;
  }
}
</style> 